<div class="m-4">
  <div class="row px-3">
    <div class="col-12">
      <p class="titleFont">
        {{ "label.claim.claimDetails.factsLabel" | translate }}
      </p>
    </div>
  </div>
  <div class="px-3 py-4">
    <div class="row mb-2">
      <div class="col-11">
        <dxc-textarea
        [value]="mannerOfDeathText"
        (onChange)="onChange($event)"
        [disabled]="true"> </dxc-textarea>
      </div>
      <div class="col-1 Image">
        <img src="{{ editIcon }}" alt="" />
      </div>
    </div>

    <div class="row endButtons">
      <custom-button
        class="saveBtn"
        label="{{ 'processClaims.decisionAndSettlement.save' | translate }}"
        mode="primary"
        margin="xsmall"
        (onClick)="onCloseDialog()"
      >
      </custom-button>
      <custom-button
        class="cancelBtn"
        label="{{ 'processClaims.decisionAndSettlement.cancel' | translate }}"
        mode="secondary"
        margin="xsmall"
        (onClick)="onCloseDialog()"
      >
      </custom-button>
    </div>
  </div>
</div>
